define('shared/remote/order/get',['$', 'shared/lib/RSVP', 'shared/util/state', 'shared/my/identity'], 
function ($, RSVP, state, getIdentity) {
    // ?marketCode=gb&partnerCode=none
    var URL_BASE = '/services/commerce-v4/ordermanager/';
    var ACTION_GET = 'get';
    var cache = {};

    function getById( orderId, memberId ) {
        return new RSVP.Promise(function(resolve, reject){
            var dfd = $.ajax({
                url: URL_BASE + ACTION_GET,
                type: 'GET',
                dataType: 'json',
                data: {
                    orderId: orderId,
                    memberId: memberId
                }
            });
            dfd.then( resolve, reject );
        });
    }

    return function( options ){
        var promise;
        var memberId;

        if ( options != null && options.id != null ) {
            promise = RSVP.resolve()
                .then(function(){
                    return getIdentity();
                })
                .then(function(value){
                    memberId = value;
                    if (
                        (options.cache == null || options.cache.bypass !== true) && 
                        (cache[options.id] != null && cache[options.id][memberId] != null)
                    ) {
                        return RSVP.resolve(cache[options.id][memberId]);
                    }
                    else {
                        return getById( options.id, memberId );
                    }
                });
        }
        else {
            promise = RSVP.reject('Parameter is not enough.');
        }

        return promise
            .then(function(data) {
                if ( data['Success'] !== true ) {
                    return RSVP.reject('Server failed to return current order');
                }

                cache[data.Result.Id] = cache[data.Result.Id] || {};
                cache[data.Result.Id][memberId] = data;

                return data['Result'];
            });
    };
});
